import React from "react";
import Header from "./Header";
import "../css/awar.css";
import Footer from "./Footer";
function awar() {
  return (
    <div className="hooo">
      {" "}
      <Header></Header>
      <div className="section0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4>Awards & Recognition</h4>
              <p>
                We Know What It Takes To Be a Top-Rated Digital Marketing
                Company
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="rev">
        <div className="container">
          <div className="row">
            <div className="col-12 jk">
              <p>
                Thrive Internet Marketing Agency is an award-winning digital
                marketing firm recognized for its top-quality service and
                technological expertise. With the accolades to back up our
                exemplary customer service, we take great pride in our
                operational excellence and industry-leading digital marketing
                solutions.
              </p>
            </div>
            <div className="col-12 jkk">
              <div className="row">
                <div className="col-md-5">
                  <img
                    src="https://thriveagency.com/files/Thrive-Inc.-5000-award-7th-consecutive-years-1557x2048.png"
                    alt=""
                  />
                </div>
                <div className="col-md-7">
                  <h1>
                    Inc. 5000 List <br />7 Years in a Row
                  </h1>{" "}
                  <br />
                  <br />
                  <p>
                    Our team is thrilled to have been included in the Inc. 5000
                    list of the fastest-growing companies in America for the
                    seventh consecutive year.
                    <br />
                    <br />
                    Thrive joined an elite group in 2023: Since the Inc. 5000
                    list was launched in 1982, only 1.5 percent of companies
                    featured on it have made the list for seven consecutive
                    years. Thrive ranked No. 1,459 overall in 2021 and had grown
                    by 325 percent over the previous three years.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="owa">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Digital Marketing Awards</h2>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://thriveagency.com/files/clutch-top-seo-2022-1.png"
                  alt=""
                />
                <h6>Clutch Top SEO Company</h6>
                <p>
                  Thrive has been ranked among the world’s top SEO companies by
                  Clutch for five consecutive years. As an acclaimed SEO firm,
                  we go above and beyond to position our clients to the top of
                  search results using white-hat SEO services.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://thriveagency.com/files/clutch-top-seo-2022-1.png"
                  alt=""
                />
                <h6>Clutch Top SEO Company</h6>
                <p>
                  Thrive has been ranked among the world’s top SEO companies by
                  Clutch for five consecutive years. As an acclaimed SEO firm,
                  we go above and beyond to position our clients to the top of
                  search results using white-hat SEO services.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://thriveagency.com/files/clutch-top-seo-2022-1.png"
                  alt=""
                />
                <h6>Clutch Top SEO Company</h6>
                <p>
                  Thrive has been ranked among the world’s top SEO companies by
                  Clutch for five consecutive years. As an acclaimed SEO firm,
                  we go above and beyond to position our clients to the top of
                  search results using white-hat SEO services.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://thriveagency.com/files/clutch-top-seo-2022-1.png"
                  alt=""
                />
                <h6>Clutch Top SEO Company</h6>
                <p>
                  Thrive has been ranked among the world’s top SEO companies by
                  Clutch for five consecutive years. As an acclaimed SEO firm,
                  we go above and beyond to position our clients to the top of
                  search results using white-hat SEO services.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://thriveagency.com/files/clutch-top-seo-2022-1.png"
                  alt=""
                />
                <h6>Clutch Top SEO Company</h6>
                <p>
                  Thrive has been ranked among the world’s top SEO companies by
                  Clutch for five consecutive years. As an acclaimed SEO firm,
                  we go above and beyond to position our clients to the top of
                  search results using white-hat SEO services.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://thriveagency.com/files/clutch-top-seo-2022-1.png"
                  alt=""
                />
                <h6>Clutch Top SEO Company</h6>
                <p>
                  Thrive has been ranked among the world’s top SEO companies by
                  Clutch for five consecutive years. As an acclaimed SEO firm,
                  we go above and beyond to position our clients to the top of
                  search results using white-hat SEO services.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://thriveagency.com/files/clutch-top-seo-2022-1.png"
                  alt=""
                />
                <h6>Clutch Top SEO Company</h6>
                <p>
                  Thrive has been ranked among the world’s top SEO companies by
                  Clutch for five consecutive years. As an acclaimed SEO firm,
                  we go above and beyond to position our clients to the top of
                  search results using white-hat SEO services.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://thriveagency.com/files/clutch-top-seo-2022-1.png"
                  alt=""
                />
                <h6>Clutch Top SEO Company</h6>
                <p>
                  Thrive has been ranked among the world’s top SEO companies by
                  Clutch for five consecutive years. As an acclaimed SEO firm,
                  we go above and beyond to position our clients to the top of
                  search results using white-hat SEO services.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://thriveagency.com/files/clutch-top-seo-2022-1.png"
                  alt=""
                />
                <h6>Clutch Top SEO Company</h6>
                <p>
                  Thrive has been ranked among the world’s top SEO companies by
                  Clutch for five consecutive years. As an acclaimed SEO firm,
                  we go above and beyond to position our clients to the top of
                  search results using white-hat SEO services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="opar">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3>Our Partners</h3>
            </div>
            <div className="col-lg-3 col-md-6 mt-5">
              <img
                src="https://thriveagency.com/files/Mask-Group-6.png"
                alt=""
              />
            </div>
            <div className="col-lg-3 col-md-6 mt-5">
              <img
                src="https://thriveagency.com/files/Mask-Group-6.png"
                alt=""
              />
            </div>
            <div className="col-lg-3 col-md-6 mt-5">
              <img
                src="https://thriveagency.com/files/Mask-Group-6.png"
                alt=""
              />
            </div>
            <div className="col-lg-3 col-md-6 mt-5">
              <img
                src="https://thriveagency.com/files/Mask-Group-6.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="arti">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3>Featured Articles</h3>
              <p>
                Thrive has consistently been featured on the world’s biggest
                websites, including UpCity and Yahoo! News, positioning our
                brand as a thought leader in the digital marketing space.
              </p>
            </div>
            <div className="col-md-6 mt-5">
              <div className="box">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src="https://thriveagency.com/files/Group-7551.png"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6">
                    <a href="/#">How Franchises Stand Out in a Local Market</a>
                    <p>February 2022</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-5">
              <div className="box">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src="https://thriveagency.com/files/Group-7551.png"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6">
                    <a href="/#">How Franchises Stand Out in a Local Market</a>
                    <p>February 2022</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-5">
              <div className="box">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src="https://thriveagency.com/files/Group-7551.png"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6">
                    <a href="/#">How Franchises Stand Out in a Local Market</a>
                    <p>February 2022</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-5">
              <div className="box">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src="https://thriveagency.com/files/Group-7551.png"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6">
                    <a href="/#">How Franchises Stand Out in a Local Market</a>
                    <p>February 2022</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-5">
              <div className="box">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src="https://thriveagency.com/files/Group-7551.png"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6">
                    <a href="/#">How Franchises Stand Out in a Local Market</a>
                    <p>February 2022</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-5">
              <div className="box">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src="https://thriveagency.com/files/Group-7551.png"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6">
                    <a href="/#">How Franchises Stand Out in a Local Market</a>
                    <p>February 2022</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default awar;
